import { supabase } from "@/integrations/supabase/client";

export interface AdminAuthStatus {
  is_admin: boolean;
  two_factor_enabled: boolean;
  session_verified: boolean;
}

/** Read authorization for this signed session. Never interpret errors as no 2FA. */
export async function getAdminAuthStatus(): Promise<AdminAuthStatus> {
  const { data, error } = await supabase.rpc("get_admin_auth_status");
  if (error) throw error;
  if (!data || typeof data !== "object" || Array.isArray(data) ||
      typeof data.is_admin !== "boolean" ||
      typeof data.two_factor_enabled !== "boolean" ||
      typeof data.session_verified !== "boolean") {
    throw new Error("Invalid admin authorization status");
  }
  return data as unknown as AdminAuthStatus;
}
